@if ((hideHeader$ | async) === false) {
  <mat-toolbar color="primary" class="app-toolbar">
    <button mat-icon-button (click)="toggleMenu()" aria-label="Menu" i18n-aria-label>
      <mat-icon>menu</mat-icon>
    </button>
    <span class="title" i18n>Copilot</span>
    <ng-container sharedContainer="Toolbar"></ng-container>
  </mat-toolbar>
}
<mat-sidenav-container class="sidenav-container" [class.no-header]="hideHeader$ | async">
  @if ((hideHeader$ | async) === false) {
    <mat-sidenav #drawer
                class="sidenav"
                fixedInViewport
                [attr.role]="(isHandset$ | async)?.matches ? 'dialog' : 'navigation'"
                [mode]="(isHandset$ | async)?.matches ? 'over' : 'side'"
                [opened]="!(isHandset$ | async)?.matches">

      <mat-toolbar color="primary">
        <span i18n>Menu</span>
      </mat-toolbar>

      <mat-nav-list>
        <a mat-list-item routerLink="/home" (click)="drawer.close()">
          <mat-icon matListItemIcon>home</mat-icon>
          <span matListItemTitle i18n>Home</span>
        </a>

        @if(rightsService.hasAny([RightType.SYSTEM_ADMIN])) {
          <a mat-list-item routerLink="/admin/phones">
            <mat-icon matListItemIcon>call</mat-icon>
            <span matListItemTitle i18n>Phone Numbers</span>
          </a>
        }

        @if (rightsService.hasAny([RightType.ADMIN, RightType.READ_ORGANIZATION, RightType.UPDATE_ORGANIZATION])) {
          <mat-tree [dataSource]="orgTreeDataSource" [childrenAccessor]="childrenAccessor" [trackBy]="trackByNode" class="org-tree">
            <!-- Nested nodes with children -->
            <mat-nested-tree-node *matTreeNodeDef="let node"
                                  (expandedChange)="onToggleNode(node)">
              <div class="mat-tree-node-container">
                @if (!leafNodes.has(node.uiId)) {
                <button mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                        class="tree-toggle-button">
                    <mat-icon class="toggle-icon" [class.expanded]="expandedNodes.has(node.uiId)">chevron_right</mat-icon>
                </button>
                } @else {
                  <span class="tree-toggle-placeholder"></span>
                }
                <a [routerLink]="node.id === 'root' ? ['/org', 'list'] : ['/org', node.authId, node.id]"
                   (click)="$event.stopPropagation()"
                   class="org-link">
                   @if(node.thumbnail) {
                    <img [src]="node.thumbnail" alt="{{ node.name }}" class="org-thumbnail" />
                   }
                  <span>{{ node.name }}</span>
                </a>
              </div>
              <div class="mat-tree-nested-nodes" [class.expanded]="expandedNodes.has(node.uiId)">
                <ng-container matTreeNodeOutlet></ng-container>
              </div>
            </mat-nested-tree-node>
          </mat-tree>
        }

        @if (organization) {
          <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}">
            <mat-icon matListItemIcon>domain</mat-icon>
            <span matListItemTitle>{{ organization.name }}</span>
          </a>

          <div class="indent">
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/dashboard">
              <mat-icon matListItemIcon>dashboard</mat-icon>
              <span matListItemTitle i18n>Dashboard</span>
            </a>
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/details">
              <mat-icon matListItemIcon>dynamic_form</mat-icon>
              <span matListItemTitle i18n>Settings</span>
            </a>
            @if (rightsService.hasAny([RightType.ADMIN], organization)) {
              <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/admins">
                <mat-icon matListItemIcon>supervisor_account</mat-icon>
                <span matListItemTitle i18n>Administrators</span>
              </a>
            }
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/members">
              <mat-icon matListItemIcon>person</mat-icon>
              <span matListItemTitle i18n>Members</span>
            </a>
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/phones">
              <mat-icon matListItemIcon>contact_phone</mat-icon>
              <span matListItemTitle i18n>Subscribers</span>
            </a>
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/content">
              <mat-icon matListItemIcon>library_books</mat-icon>
              <span matListItemTitle i18n>Content</span>
            </a>
            <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/calendar">
              <mat-icon matListItemIcon>calendar_month</mat-icon>
              <span matListItemTitle i18n>Calendar</span>
            </a>
            <!-- @if (organization.inbox?.id === organization.id) {
              <a mat-list-item routerLink="/org/{{ authId }}/{{ organization.id }}/schedule">
                <mat-icon matListItemIcon>schedule</mat-icon>
                <span matListItemTitle i18n>Schedule</span>
              </a>
            } -->

          </div>
        }

        @if (rightsService.hasAny([RightType.INBOX_ACCESS])) {
          <a mat-list-item routerLink="/inbox" (click)="drawer.close()">
            <mat-icon matListItemIcon>inbox</mat-icon>
            <span matListItemTitle i18n>Inbox</span>
          </a>
        }

        @if (false) {
        <a mat-list-item routerLink="/resources" (click)="drawer.close()">
          <mat-icon matListItemIcon>library_books</mat-icon>
          <span matListItemTitle i18n>Resources</span>
        </a>
        }

        <hr />

        <button matButton (click)="logout(); drawer.close();">
          <mat-icon matListItemIcon>logout</mat-icon>
          <span matListItemTitle i18n>Logout</span>

        </button>
      </mat-nav-list>
    </mat-sidenav>
  }
  <mat-sidenav-content>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
